import React from 'react'
import { Query, Mutation } from 'react-apollo'
import { Collapse, message } from 'antd'
import _ from 'lodash'
import {
  Div, H3, Loading, P, SmallText,
} from 'konsys-ui'
import { theme } from '../../../styles/_variables'
import { GET_ROLES } from '../../../constants/graphql/query'
import { UPDATE_ROLE } from '../../../constants/graphql/mutation'
import { IconSelector } from '../util-functions'
import PERMISSION from '../../../constants/permissions'
import { RoleList, ActionCheckBoxContainer, ActionCheckBox } from './styled'

const { color } = theme

const Index = () => (
  <Div style={{ overflowX: 'auto', overflowY: 'hidden' }}>
    <Div display='flex' flexDirection='column' style={{ minWidth: 922 }}>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <H3 bold color={color.primaryColor} margin='32px 0'>จัดการหน้าที่และการเข้าถึง</H3>
      </Div>
      <List />
    </Div>
  </Div>
)

const HeaderItem = props => (
  <Div padding='8px' width='100px' height='80px' alignItems='center' justifyContent='flex-start' display='flex' flexDirection='column'>
    {
      IconSelector(props.id)
    }
    <Div width='100%' textAlign='center'>
      <SmallText bold color={color.coolGrey} textAlign='center'>
        {props.title}
      </SmallText>
    </Div>
  </Div>
)

const Item = props => (
  <Div width='100px' textAlign='center' padding='0 0 0 8px'>
    <Mutation
      mutation={UPDATE_ROLE}
    >{doUpdateRole => (
      <ActionCheckBox
        disabled={!_.includes(window.perms, PERMISSION.UPDATE_ROLE)}
        defaultChecked={props.value}
        data={{ value: `${props.id}__${props.permissionId}`, text: '' }}
        onChange={(e) => {
          doUpdateRole({
            variables: { id: props.id, permissionId: props.permissionId, isActive: e.target.checked },
          }).then((resp) => {
            const mappedResp = resp.data.UpdateRole
            message.config({ maxCount: 1 })
            if (mappedResp.success) message.success(mappedResp.message)
            else message.error(mappedResp.message)
          })
        }}
      />
    )}
    </Mutation>
  </Div>
)

const HeaderRow = ({ contents }) => (
  <RoleList>
  {
    contents.map(v => <HeaderItem key={v.id} title={v.name} id={v.id}/>)
  }
  </RoleList>
)

const Row = ({ title, contents }) => (
  <ActionCheckBoxContainer>
    <Div margin='0 78px 0 0' textAlign='left'>
      <P>{title}</P>
    </Div>
    <Div>
    {
      contents.map(v => (
        <Item id={v.id} permissionId={v.permissionId} key={`${v.id}__${v.permissionId}`} value={v.active} name={v.name} width='150px'/>
      ))
    }
    </Div>
  </ActionCheckBoxContainer>
)

export const List = () => {
  const { Panel } = Collapse

  return (
    <Query
      query={GET_ROLES}
      fetchPolicy='network-only'
    >{({ data, loading, error }) => {
      if (loading) return <Loading center/>
      if (error) return <H3>เกิดข้อผิดพลาด</H3>

      const mapped = data.RoleList.lists
      return (
          <Div margin='auto'>
            <HeaderRow contents={mapped.map(v => ({ name: v.description, id: v.id }))} />
            <Collapse bordered={false}>
            {
              mapped[0].allowModules.map(v => (
                <Panel header={v.name} key={v.name} style={{
                  fontWeight: 400, fontSize: 16,
                }}>
                  {
                    v.Permissions.map(pe => (
                      <Row
                        key={pe.name}
                        title={pe.description}
                        contents={mapped.map(i => ({ ..._.find(_.find(i.allowModules, o => o.name === v.name).Permissions, mappedP => mappedP.name === pe.name), id: i.id }))}
                      />
                    ))
                  }
                </Panel>
              ))
            }
            </Collapse>
          </Div>
      )
    }}</Query>
  )
}

export default Index
